import PropTypes from "prop-types";

import WarningIcon from "assets/svg/form-warning.svg";

import styles from "./styles.module.css";

const ErrorStep = ({ goBack, samePersonError }) => {
  const errorMessage = samePersonError || "Bilgilerinizi şu an iletemedik. Lütfen tekrar deneyin.";
  const ctaLabel = samePersonError ? "Tamam" : "Tekrar Dene";
  return (
    <div className={styles.errorContainer}>
      <WarningIcon className={styles.errorIcon} />
      <p className={styles.errorTitle}>Üzgünüz</p>
      <p className={styles.errorText}>{errorMessage}</p>
      <p className={styles.errorText}>
        Sorun yaşıyorsanız bize <strong>0216 251 0166</strong> ’yı
        <br />
        arayarak ulaşabilirsiniz.
      </p>
      <button className={styles.errorButton} onClick={goBack}>
        {ctaLabel}
      </button>
    </div>
  );
};

ErrorStep.propTypes = {
  goBack: PropTypes.func.isRequired,
  samePersonError: PropTypes.string,
};

export default ErrorStep;
